<template>
  <v-layout row justify-center>
    <v-dialog v-model="ageDialog" attach="#main-card" persistent max-width="350">
      <v-card>
        <v-toolbar dark color="primary lighten-1">
          <v-toolbar-title>Alter</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-select :items="items" menu-props="auto" label="Alter" v-model="age" item-text="18" item-value=18
            solo></v-select>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="alertDialog" persistent max-width="350">
      <v-card>
        <v-toolbar dark color="primary lighten-1">
          <v-toolbar-title>Achtung!</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          Der Abschluss dieses Vertrages ist erst ab {{ minAge }} Jahren möglich.
        </v-card-text>
        <v-card-actions>
          <v-btn class="secondary" @click="alertDialog = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "DialogAskForAge",
  data() {
    return {
      ageDialog: true,
      alertDialog: false,
      items: [...Array(100).keys()]
    };
  },
  watch: {
    ageDialog: function () {
      let self = this;
      if (this.$store.state.work.clientContext.parent) {
        if (this.ageDialog) {
          this.$store.dispatch('work/postMessageNewMessage', "Die Altersangabe wird für die Beitragsberechnung benötigt.");
        }
        else {
          this.$store.dispatch('work/postMessageNewMessage', "");
          parent.postMessage({
            id: "sk_4g_p1",
            content: "Angegebenes Alter: " + this.age + " Jahre."
          }, "*");
        }
      }
    }
  },
  computed: {
    age: {
      get() {
        return this.$store.state.work.supposedlyAge;
      },
      set(value) {
        let group = 0;
        this.$store.commit("work/SET_SUPPOSEDLY_AGE", value);
        if (value >= this.minAge && value <= 30) { group = 1; }
        if (value > 30) { group = 2; }
        this.$store.commit("work/SET_SUPPOSEDLY_AGEGROUP", group);
        if (group == 0) {
          this.alertDialog = true;
        }
        else {
          this.ageDialog = false;
        }
      }
    },
    minAge() {
      return this.isOnlineGs ? 16 : 18;
    },
    ...mapGetters("work", {
      isOnlineGs: "getIsOnlineGs"
    })
  },
  mounted() {
    this.$store.dispatch('work/postMessageNewHeight');
    this.$store.dispatch('work/postMessageNewMessage', "Die Altersangabe wird für die Beitragsberechnung benötigt.");
  }
};
</script>

<style scoped></style>
